// Template: Add your feature flag here
// export const YOUR_FLAG_NAME_COOKIE_KEY = 'yourFlagName';
export const MATCHA_ACCOUNT = 'matcha-account';
export const HOMEPAGE_REVAMP = 'homepage-revamp';
export const DEDAUB_TOKEN_CHECK = 'dedaub-token-check';
/** Render advanced orders on /trade with the native SVG chart instead of TradingView. */
export const ADVANCED_ORDER_NATIVE_CHART = 'advanced-order-native-chart';
/** Enforce the candidate CSP; otherwise collect reports without blocking resources. */
export const STRICT_CSP = 'strict-csp';
/** Show the Perps navigation and serve /perps; otherwise /perps is a 404. */
export const PERPS = 'matcha-perps';
/** Skip the perps geo restriction so trading can be tested from a blocked region. */
export const BYPASS_GEO = 'bypass-geo';

export type FeatureFlagValues = Record<typeof HOMEPAGE_REVAMP | typeof DEDAUB_TOKEN_CHECK, boolean>;

export const DEFAULT_FEATURE_FLAGS: FeatureFlagValues = {
  [HOMEPAGE_REVAMP]: false,
  [DEDAUB_TOKEN_CHECK]: false,
};

/// List of supported feature flags.
export const SUPPORTED_FEATURE_FLAGS: string[] = [
  // feature flags here
  // YOUR_FLAG_NAME_COOKIE_KEY,
  MATCHA_ACCOUNT,
  HOMEPAGE_REVAMP,
  DEDAUB_TOKEN_CHECK,
  ADVANCED_ORDER_NATIVE_CHART,
  STRICT_CSP,
  PERPS,
  BYPASS_GEO,
];
